import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/new/file_video.png'
import _imports_1 from '@/assets/img/new/file_live.png'
import _imports_2 from '@/assets/img/new/down_active_icon.png'
import _imports_3 from '@/assets/img/new/down_icon.png'
import _imports_4 from '@/assets/img/new/null_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-360abf16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home_box" }
const _hoisted_2 = { class: "collect_scroll" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_7 = { class: "collect_popup" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  src: _imports_2,
  alt: ""
}
const _hoisted_10 = {
  key: 1,
  src: _imports_3,
  alt: ""
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "下载", -1))
const _hoisted_12 = {
  key: 1,
  class: "null_box"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "暂无数据", -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  key: 2,
  class: "pagin_box"
}
const _hoisted_17 = { class: "pagin_tiao" }

import { onMounted, onUnmounted, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex';
import { TResponse, TTotal } from "@/module/common"
import { SearchPageList } from "@/module/search";
import { getSearchPage } from "@/api/search";
import { ElLoading } from 'element-plus';
import bus from '@/utils/bus';
import getFileTypeImg from '@/hooks/use_type_imgs'
import { fileHandle } from '@/hooks/file_preview_download'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { onPreview, addExtension, downLoad, previewPic } = fileHandle()
let person: any = reactive({
    data: {
        list: [],
        PageIndex: 1,
        PageSize: 12,
        total: 0
    },
    keyword: 0// 关键字
})

const router = useRouter();
const store = useStore()
onMounted(() => {
    // 判断是主页，头部不加背景色
    if (router.currentRoute.value.name !== 'teaIndex') {
        store.commit('setIsBg', true)
    }
    person.keyword = useRoute().query.keyword
    GetSearchPage()
})

// 搜索接口
const GetSearchPage = async () => {
    const loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0)'
    })
    try {
        let res: TResponse<TTotal<SearchPageList[]>> = await getSearchPage({ SearchKey: person.keyword, PageIndex: person.data.PageIndex, PageSize: person.data.PageSize })
        let { Code, Data } = res
        if (Code === 200) {
            person.data.list = Data.Data
            person.data.total = Data.Total
        }
    } catch (error) {

    } finally {
        loading.close()
    }
}
//查看图片
const previewPicClick = (row: any, index: number) => {
    if (row.DownState && row.Type === 4) {
        person.data.list[index].isPic = !person.data.list[index].isPic
    }
}
//下载图片
const dowmClick = (item: any, index: number) => {
    if (!item.DownState) {
        return
    }
    downLoad(item)
}

bus.on('eventName', (data: string) => {
    person.keyword = data
    GetSearchPage()
})

//销毁
onUnmounted(()=>{
    bus.off('eventName', ()=>{})
})
// 分页
const currentChange = (val: number) => {
    person.data.PageIndex = val
    GetSearchPage()
}

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(person).data.list&&_unref(person).data.list.length>0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(person).data.list, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "collect_item",
                key: index
              }, [
                _createElementVNode("div", {
                  class: "video_img",
                  onClick: ($event: any) => (_unref(onPreview)(item,index,false))
                }, [
                  (item.ObjType === 1)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                    : (_openBlock(), _createElementBlock("img", _hoisted_6)),
                  _createElementVNode("span", null, _toDisplayString(item.Name), 1)
                ], 8, _hoisted_4),
                _createElementVNode("div", _hoisted_7, [
                  (item.ObjType===3)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "collect_ite",
                        onClick: ($event: any) => (dowmClick(item,index))
                      }, [
                        (item.DownState)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                          : (_openBlock(), _createElementBlock("img", _hoisted_10)),
                        _hoisted_11
                      ], 8, _hoisted_8))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15)),
      (_unref(person).data.total > _unref(person).data.PageSize)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createVNode(_component_el_pagination, {
              layout: "prev, pager, next, jumper",
              "current-page": _unref(person).data.PageIndex,
              "page-size": _unref(person).data.PageSize,
              total: _unref(person).data.total,
              onCurrentChange: currentChange
            }, null, 8, ["current-page", "page-size", "total"]),
            _createElementVNode("div", _hoisted_17, "每页 " + _toDisplayString(_unref(person).data.PageSize) + " 条，共 " + _toDisplayString(_unref(person).data.total) + " 条", 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})